import { Directive, Input } from '@angular/core';

@Directive({
  selector: 'ng-template[templateContext]',
})
export class TemplateContextDirective<T> {
  @Input('templateContext') templateContext!: T;

  static ngTemplateContextGuard<T>(dir: TemplateContextDirective<T>, ctx: unknown): ctx is T {
    return true;
  }
}
